var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCounelingCoupon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img \xEC\x9D\xB4\xEC\x9A\xA9\xEA\xB6\x8C\xEB\x82\xB4\xEC\x97\xAD"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1748",
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 38.5,
    stroke: "#7762DF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 20177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.7956 22.2725H51.2711C53.1348 22.2725 54.0666 23.2028 54.0666 25.0636V56.1703C54.0666 58.031 53.1348 58.9614 51.2711 58.9614H27.7956C25.9319 58.9614 25 58.031 25 56.1703V25.0636C25 23.2028 25.9319 22.2725 27.7956 22.2725Z",
    stroke: "#D6CEFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_2_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M44.0388 54.7932C44.1699 54.6634 44.2355 54.5012 44.2355 54.3066V54.2944C44.2355 54.0998 44.1699 53.9335 44.0388 53.7956C43.9153 53.6659 43.7609 53.601 43.5757 53.601H31.4098C31.2246 53.601 31.0664 53.6659 30.9352 53.7956C30.8117 53.9335 30.75 54.0998 30.75 54.2944V54.3066C30.75 54.5012 30.8117 54.6634 30.9352 54.7932C31.0664 54.9311 31.2246 55 31.4098 55H43.5757C43.7609 55 43.9153 54.9311 44.0388 54.7932ZM48.5532 49.4161C48.4297 49.2863 48.2754 49.2214 48.0902 49.2214H31.4098C31.2246 49.2214 31.0664 49.2863 30.9352 49.4161C30.8117 49.5539 30.75 49.7202 30.75 49.9148V49.927C30.75 50.1217 30.8117 50.2839 30.9352 50.4136C31.0664 50.5515 31.2246 50.6204 31.4098 50.6204H48.0902C48.2754 50.6204 48.4297 50.5515 48.5532 50.4136C48.6844 50.2839 48.75 50.1217 48.75 49.927V49.9148C48.75 49.7202 48.6844 49.5539 48.5532 49.4161ZM48.5532 45.1947C48.4297 45.0649 48.2754 45 48.0902 45H31.4098C31.2246 45 31.0664 45.0649 30.9352 45.1947C30.8117 45.3325 30.75 45.4988 30.75 45.6934V45.7056C30.75 45.9002 30.8117 46.0624 30.9352 46.1922C31.0664 46.3301 31.2246 46.399 31.4098 46.399H48.0902C48.2754 46.399 48.4297 46.3301 48.5532 46.1922C48.6844 46.0624 48.75 45.9002 48.75 45.7056V45.6934C48.75 45.4988 48.6844 45.3325 48.5532 45.1947Z",
    fill: "#D6CEFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_3_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.9805 21.4407V22.9171C30.9805 23.2109 31.1276 23.3578 31.4219 23.3578H47.6436C47.9378 23.3578 48.085 23.2109 48.085 22.9171V21.4407C48.085 21.1469 47.9378 21 47.6436 21H31.4219C31.1276 21 30.9805 21.1469 30.9805 21.4407Z",
    fill: "#D6CEFF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M31.4219 21H47.6436C47.9378 21 48.085 21.1469 48.085 21.4407V22.9171C48.085 23.2109 47.9378 23.3578 47.6436 23.3578H31.4219C31.1276 23.3578 30.9805 23.2109 30.9805 22.9171V21.4407C30.9805 21.1469 31.1276 21 31.4219 21Z",
    stroke: "#D6CEFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer0_2_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M49.1875 34.1438C49.1875 35.5607 48.6846 36.7713 47.6789 37.7754C46.9064 38.5467 46.012 39.021 44.9956 39.1983V41.663L41.8472 39.2816H35.8962C34.477 39.2816 33.2646 38.7796 32.2588 37.7754C31.2531 36.7713 30.7502 35.5607 30.7502 34.1438V34.1378C30.7502 32.7209 31.2531 31.5104 32.2588 30.5062C33.2646 29.5021 34.477 29 35.8962 29H44.0415C45.4607 29 46.6731 29.5021 47.6789 30.5062C48.6846 31.5104 49.1875 32.7209 49.1875 34.1378V34.1438Z",
    fill: "#D6CEFF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M44.0412 29.0029H35.8959C34.4768 29.0029 33.2643 29.505 32.2586 30.5091C31.2529 31.5133 30.75 32.7238 30.75 34.1407V34.1467C30.75 35.5636 31.2529 36.7741 32.2586 37.7783C33.2643 38.7824 34.4768 39.2845 35.8959 39.2845H41.8469L44.9953 41.6659V39.2041C46.0116 39.0248 46.9061 38.5495 47.6786 37.7783C48.6843 36.7741 49.1872 35.5636 49.1872 34.1467V34.1407C49.1872 32.7238 48.6843 31.5133 47.6786 30.5091C46.6728 29.505 45.4604 29.0029 44.0412 29.0029Z",
    fill: "#D6CEFF",
    stroke: "#D6CEFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounelingCoupon);
export default __webpack_public_path__ + "static/media/couneling_coupon.91c5ed96638e57fabccdbc239da90c72.svg";
export { ForwardRef as ReactComponent };